import React, { FunctionComponent } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { OptionId, SegmentTypes } from '../../../../../../../models/itinerary';
import { AppState } from '../../../../../../../store/model';
import { getSegmentType, isSaviSelectIntl } from '../../../../../../../store/reducers/itinerary/selectors';
import { AirProviderDetailsContainer } from './AirProviderDetailsContainer';
import { CarProviderDetailsContainer } from './CarProviderDetailsContainer';
import { HotelProviderDetailsContainer } from './HotelProviderDetailsContainer';
import { getSegmentTypeForSaviSelectIntl } from '../../../../../../../store/reducers/itinerary/saviSelectIntlSelector';

interface OwnProps {
  optionId: OptionId;
  segmentId: number;
}

interface StateProps {
  type: SegmentTypes;
}

interface ProviderDetailsProps extends OwnProps, StateProps {}

const ProviderDetailsBase: FunctionComponent<ProviderDetailsProps> = ({
  optionId,
  segmentId,
  type,
}) => {
  switch (type) {
    case 'Air':
      return (
        <AirProviderDetailsContainer
          optionId={optionId}
          segmentId={segmentId}
        />
      );
    case 'Car':
      return (
        <CarProviderDetailsContainer
          optionId={optionId}
          segmentId={segmentId}
        />
      );
    case 'Hotel':
      return (
        <HotelProviderDetailsContainer
          optionId={optionId}
          segmentId={segmentId}
        />
      );
  }
};

const mapStateToProps = (state: AppState, { segmentId }: OwnProps) => {
  return {
    type: !isSaviSelectIntl(state) ? getSegmentType(segmentId)(state) : getSegmentTypeForSaviSelectIntl(segmentId)(state)
  };
};

const enhance = compose<ProviderDetailsProps, OwnProps>(
  pure,
  connect(mapStateToProps),
  injectIntl,
);

/**
 * Automatically detect the type of provider, and render the correct type of ProviderDetails component.
 *
 * Types that can be detected: `Air`, `Car`, `Hotel` (type: `SegmentType`)
 *
 * The type is detected by hooking into the Redux store, and finding the segment by a given segmentId (in `props`).
 */
export const ProviderDetailsContainer = enhance(ProviderDetailsBase);

ProviderDetailsContainer.displayName = 'ProviderDetailsContainer';
